import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import omit from 'lodash/omit';
import isNumber from 'lodash/isNumber';
import C7NProgress from 'choerodon-ui/lib/progress';
import { FormField } from '../field/FormField';
let Progress = class Progress extends FormField {
    getValue() {
        const value = super.getValue();
        if (isNumber(value)) {
            return value;
        }
        return this.props.percent;
    }
    render() {
        return (React.createElement(C7NProgress, Object.assign({}, omit(this.props, ['dataSet', 'showHelp', 'renderer']), { percent: this.getValue() })));
    }
};
Progress.displayName = 'Progress';
Progress = __decorate([
    observer
], Progress);
export default Progress;
